import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { BrokerService } from 'src/app/core/services/broker.service';
import { DataLayersService } from 'src/app/core/services/data-layers.service';
import { LoadService } from 'src/app/core/services/load.service';
import { OfferService } from 'src/app/core/services/offer.service';
import { SesionService } from 'src/app/core/services/sesion.service';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { environment } from 'src/environments/environment';
import { timeout, TimeoutError } from 'rxjs';
import { CONECTAS_ROUTE_MAP } from 'src/app/shared/bc-connect/interfaces/conectas-route-map';
declare var $: any;
@Component({
    selector: 'app-landing-offer',
    templateUrl: './landing-offer.component.html',
    styleUrls: ['./landing-offer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LandingOfferComponent implements OnInit {
  public companyId: string | null = "";
  public offerId: string | null = "";
  public cellphone: string | null;
  public cookie = "";
  public offerUnique: any;
  public textScore = '';
  public colorScore = 'bajo';
  public id = 0;
  public urlLogin = environment.urlLogin;
  public btn_retomar_aplicacion = false;
  public cardForTC: boolean = false;
  public threeLabels = false;
  // Objeto de configuracion de etiquetas de la oferta donde 0 es por defecto la tarjeta sin etiqueta
  public configLabel: any = {
    '0': { color: 'blue', img: '', showLabel: false },
    '1': { color: 'orange', img: 'assets/icons/oferta_destacada_estrella.svg', showLabel: true },
    '2': { color: 'green', img: 'assets/icons/icono_etiqueta_nueva.svg', showLabel: true },
    '3': { color: 'blue', img: 'assets/icons/icono_etiqueta_regular.svg', showLabel: true },
  }
  constructor(public broker: BrokerService,
    private cookieService: CookieService,
    private load: LoadService,
    private route: ActivatedRoute, private router: Router,
    public utilities: UtilitiesService, public offer: OfferService,
    public sesion: SesionService,
    private dataLayerService: DataLayersService) {
    this.sesion.header = 1;
    this.cellphone = localStorage.getItem('userPhone');
  }

  ngOnInit(): void {
    this.companyId = this.route.snapshot.paramMap.get('companyId');
    this.offerId = this.route.snapshot.paramMap.get('offerId');
    this.cookie = this.sesion.sesionCookie;
    this.validateUser();

  }

  validateUser() {
    const data = {
      clientId: environment.clientId,
      idSession: this.sesion.sesionCookie,
      country: environment.country
    };
    this.load.open('#loader', '', '', false, undefined);
    this.broker.validar_sesion(data).subscribe({
      next: (res: any) => {
        this.sesion.isSessionValid = true;
        this.sesion.sesionCookie = this.cookieService.get('IDSESSIONMDC');
        this.sesion.nameSession = res.nombre;
        this.sesion.dataUser = res;
        this.broker.getIncomeInfo().subscribe({
          next: (resEcs: any) => {
            this.sesion.ecsInfo = resEcs;
            if (resEcs.params.length > 1) {
              this.sesion.userPhone = resEcs.params[1].value;
              this.cellphone = resEcs.phone;
              localStorage.setItem('userPhone', resEcs.params[1].value);
            }
            if (this.sesion.ecsInfo.params[3].value) {
              this.sesion.stepConfirmTelephone = 4;
            }
            this.getOffer();
          }, error: () => {
            document.cookie = 'IDSESSIONMDC=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            this.router.navigate(['/error']);
            this.sesion.sesionCookie = null;
          }
        })
      }, error: (error: any) => {
        document.cookie = 'IDSESSIONMDC=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        this.sesion.sesionCookie = null;
        this.getOffer();
      }
    });
  }

  getOffer() {
    let json = {
      idSession: this.sesion.sesionCookie == null ? '' : this.sesion.sesionCookie,
      companyId: this.companyId,
      offerId: this.offerId
    }
    localStorage.removeItem('landingByOffer');
    this.broker.consultarDetalle(json, 2).pipe(timeout(15000)).subscribe({
      next: (res: any) => {
        try {
          if (res.company != undefined) {
            let offers = [
              {
                company: res.company,
                offers: [
                  res.offer
                ]
              }
            ];
            this.offerUnique = this.offer.convertOffer(offers)[0];
            this.offer.offersList = this.offer.convertOffer(offers);
            this.offer.offerSelected = this.offerUnique;
            this.id = this.offerUnique.company.id + this.offerUnique.offerId;
            this.setTextScore();
            this.threeLabels = (this.offerUnique.card.offerDetail1 != undefined);
            let isTC = this.offerUnique.detail.subcategories.filter((ele: any) => ele == 'TC');
            if (isTC.length > 0) {
              this.cardForTC = true;
            }
            this.sesion.dataOffer["companyId"] = this.offerUnique.company.id;
            this.sesion.dataOffer["offerId"] = this.offerUnique.offerId;
            this.sesion.dataOffer["companyName"] = this.offerUnique.company.name;
            this.sesion.dataOffer["productName"] = this.offerUnique.card.productName;
            this.sesion.dataOffer["landingByOffer"] = '1';
            this.load.close('#loader');
            setTimeout(() => {
              if (localStorage.getItem("companyId") != null && localStorage.getItem('offerId') != null && localStorage.getItem('isHome') == null) {
                let applyBefore = this.offer.offersList.find((ele: any) => ele.company.id == localStorage.getItem("companyId") && ele.offerId == localStorage.getItem('offerId'));
                if (applyBefore != undefined) {
                  this.validateOfferInProcess(applyBefore);
                } else {
                  this.offer.clearOfferlocalStorage();
                }
              }
            }, 1000)
            this.dataLayerService.dl_eventoGA4_view_offer(
              this.offerUnique.card.productName,
              String(this.offerUnique.offerId),
              this.offerUnique.company.name,
              DataLayersService.getOfferIsFeatured(this.offerUnique.labelType),
              DataLayersService.getOfferLabel(this.offerUnique.labelType, this.offerUnique.textLabel)
            );
          }
        } catch (error) {
          this.router.navigate(['/error']);
          this.load.close('#loader');
        }

      },
      error: (error) => {
        // Solo mostrar modal de rechazo cuando:
        // 1. El usuario TIENE sesión activa (está autenticado)
        // 2. userOfferDetail?param=2 retorna HTTP 500
        // 3. El mensaje indica que no cumple criterios
        const isAuthenticated = this.sesion.sesionCookie != null && this.sesion.sesionCookie !== '';
        const isHttp500 = error?.status === 500;
        const noCumpleCriterios = isAuthenticated && isHttp500 && !!(error?.error?.message?.length > 0 &&
          error.error.message[0] === 'Error generando detalle de oferta: El usuario no cumple con los criterios de las ofertas');

        if (noCumpleCriterios) {
          // Cerrar el loader y esperar a que termine para mostrar el modal de rechazo
          const $loader = $('#loader');
          const showRejectionModal = () => {
            this.load.typeNoOffers = 1;
            this.load.open('#noOfertasModal', '', '', false, undefined);
          };

          if ($loader.hasClass('show') || $loader.hasClass('in')) {
            $loader.one('hidden.bs.modal', () => {
              showRejectionModal();
            });
            $loader.modal('hide');
          } else {
            showRejectionModal();
          }
        } else {
          this.load.close('#loader');
          this.router.navigate(['/error']);
        }
      }
    });
  }

  /**
   * Funcion para determinar que boton mostrar al usuario
   * @returns tipo de botn a mostrar 1 = aplicar oferta, 2 = retomar aplicacion, 3 = oferta aplicada
   */

  selectButton() {
    if (!this.offerUnique.isApplied) {
      return 1;
    } else if ((this.offerUnique.isApplied) && (this.offerUnique.detail.urlRedirect != undefined || this.offerUnique.urlRedirect != '')) {
      return 2;
    } else if (this.offerUnique.isApplied && this.offerUnique.detail.urlRedirect == undefined && this.offerUnique.urlRedirect == '') {
      return 3;
    } else {
      return 1;
    }
  }

  /**
   * Funcion que consume el servicio de datalayer y valida si la oferta es gratuita lo redirecciona a la pagina del aliado configurada, si no es gratuita valida si el usuario tinene sesion
   * si la tiene sesion abre el modal de confirmacion y si no guarda unos valores en el localstorage y lo redirecciona al sso
   */
  applyOffer(event: MouseEvent) {
    this.dataLayerService.dl_eventoGA4_event_button('clic_oferta-destacada', (event.target as HTMLElement).innerText);
    localStorage.setItem('offerId', this.offerUnique.offerId);
    localStorage.setItem('companyName', this.offerUnique.company.name);
    localStorage.setItem('productName', this.offerUnique.card.productName);
    localStorage.removeItem('isHome')
    localStorage.setItem('landingByOffer', '1');
    this.offer.offerSelected = this.offerUnique;
    // GA4 - evento data layer select_content que envía la información de la oferta seleccionada
    this.dataLayerService.dl_eventoGA4_content(
      'select_content',
      this.offerUnique.card.productName,
      String(this.offerUnique.offerId),
      this.offerUnique.company.name,
      DataLayersService.getOfferIsFeatured(this.offerUnique.labelType),
      DataLayersService.getOfferLabel(this.offerUnique.labelType, this.offerUnique.textLabel)
    );
    if (this.offerUnique.free == true) {
      this.processOfertFree();
    } else {
      this.processOfert();
    }
  }

  processOfertFree() {
    let url = this.offerUnique.detail.urlRedirect;
    if (url.includes("https://") || url.includes("http://")) {
      window.location.href = url;
    } else {
      window.location.href = 'https://' + url;
    }
  }

  processOfert() {
    if (this.sesion.isIdsession()) {
      this.offer.validateSoftFilters();
    } else {
      window.location.href = this.urlLogin;
    }
  }

  /**
   * Funcion que dependiendo del aliado consume el servicio de /applyOffer 0 /davivienda, si llama a /applyOffer y el consumo es exitoso redirecciona 
   * a la pagina que responde el servicio
   */
  redirect(event: MouseEvent) {
    this.btn_retomar_aplicacion = true;
    this.dataLayerService.dl_eventoGA4_event_button('clic_oferta-destacada', (event.target as HTMLElement).innerText);
    this.enviar_dl(this.offerUnique);
    if (this.offerUnique.settings.conecta) {
      this.continueApply();
    } else {
      const body = {
        idSession: this.sesion.sesionCookie,
        cellPhone: this.cellphone,
        country: "CO"
      }
      let dataOferta = {
        idSession: this.sesion.sesionCookie,
        companyId: this.offerUnique.company.id,
        offerId: this.offerUnique.offerId
      }
      if (this.offerUnique.company.id == "860034313") {
        let dataOfertaDav = {
          idSession: this.sesion.sesionCookie,
          userAgent: "",
          idDevice: ""
        }
        this.broker.aplicarOfertaDav(dataOfertaDav).subscribe((resultado: any) => {
          if (resultado.body.includes("http")) {
            this.open_offer_page(encodeURI(resultado.body));
          } else {
            this.router.navigate(['/error']);
          }
        });
      }
      else {
        this.broker.aplicarOferta(dataOferta).subscribe({
          next: (resultado: any) => {
            if (resultado.orderNumber) {
              this.offer.offerApplied = resultado;
              this.offer.offerSelected.isApplied = true;
              const urlRedirect = resultado.applyDetail.urlRedirect;
              const urlEncriptedData = resultado.applyDetail.urlEncriptedData;
              if (urlRedirect != "" || urlRedirect != undefined) {
                let urlRedirect = resultado.applyDetail.urlRedirect;

                // Solo para aliado Credissimo
                if (this.offerUnique.company.id == "901146443") {
                  this.open_offer_page(urlRedirect + '?bon=' + resultado.orderNumber);
                }
                // Solo para aliado Solventa
                else if (this.offerUnique.company.id == "901255144") {
                  this.broker.sendEncriptedData(body, urlEncriptedData + resultado.encryptedInfo);
                  this.open_offer_page(urlRedirect);
                }
                // Para todos
                else {
                  if (this.hasQueryString(urlRedirect)) {
                    urlRedirect = urlRedirect + '&lead=' + encodeURIComponent(resultado.encryptedInfo);
                  }
                  else {
                    urlRedirect = urlRedirect + '?lead=' + encodeURIComponent(resultado.encryptedInfo);
                  }
                  this.offerUnique.preselecta.urlRedirect = urlRedirect;
                  this.open_offer_page(urlRedirect);
                }
              }
            } else {
              $("#noDav" + this.id).show();
              $("#noDav_M" + this.id).show();
            }
          },
          error: error => {
            this.errorService();
          }
        });
      }
    }
  }

  /**
   * Funcion que cierra modal de error y redirecciona a pagina de error general
   */
  errorService() {
    this.offer.errorApply = false;
    this.sesion.semiValid = false;
    this.load.close("#confirmationModalV2");
    this.router.navigate(['/error']);
  }

  /**
   * Funcion para validar si una url contiene querystring
   * @param url url a verificar
   * @returns si la url tiene formato con queryString
   */
  hasQueryString(url: any) {
    let reg = new RegExp('[?&][a-zA-Z]', 'g');
    let queryString = reg.exec(url);
    if (queryString != null) {
      return queryString.length > 0 ? true : false;
    }
    return false;
  }


  // Esté método abre la página del aliado cuando el usuario retoma la aplicación
  open_offer_page(url: string) {
    setTimeout(() => {
      window.location.href = url;
      setTimeout(() => {
        this.btn_retomar_aplicacion = false;
      }, 2500);
    }, 5000);
  }

  isButtonIdValid(buttonId: string) {
    return (typeof buttonId === 'string' ? buttonId : '0');
  }

  /**
   * Funcion que redirecciona a la pagia del alidado que este en la variable preselecta.urlRedirect,
   */
  continueApply() {
    if (this.offerUnique.urlRedirect.includes("http")) {
      window.location.href = this.offerUnique.urlRedirect;
    } else {
      window.location.href = encodeURI(this.offerUnique.urlRedirect);
    }
  }

  /**
  * Este evento enviará un data layer sobre la continuación de la aplicación "continue_application"
  * @param data_oferta información de la oferta
  */
  enviar_dl(data_oferta: any) {
    this.dataLayerService.dl_eventoGA4_content(
      'continue_application',
      data_oferta.card.productName,
      String(data_oferta.offerId),
      data_oferta.company.name,
      DataLayersService.getOfferIsFeatured(data_oferta.labelType),
      DataLayersService.getOfferLabel(data_oferta.labelType, data_oferta.textLabel)
    );
  }

  /**
   * Funcion que usa el score de la oferta para saber que texto de score mostrar en el detalle
   */
  setTextScore() {
    let score = parseInt(this.offerUnique.detail.score);
    switch (score > 0) {
      case (score >= 150 && score <= 402):
        this.textScore = "BAJO";
        this.colorScore = "bajo";
        break;
      case (score >= 403 && score <= 676):
        this.textScore = "MEDIO BAJO";
        this.colorScore = "medio-bajo";
        break;
      case (score >= 677 && score <= 748):
        this.textScore = "MEDIO";
        this.colorScore = "medio";
        break;
      case (score >= 749 && score <= 804):
        this.textScore = "MEDIO ALTO";
        this.colorScore = "medio-alto";
        break;
      case (score >= 805 && score <= 950):
        this.textScore = "ALTO";
        this.colorScore = "alto";
        break;
      default:
        this.textScore = '';
        break;
    }
  }

  /**
   * Funcion que verifica si hay una oferta a la que se intento aplicar sin estar logueado, si se encuentra la oferta
   * en la lista de ofertas de preselecta se abre el modal de actualizacion de datos y se cambia la la url para la categoria
   * y sub-categoria de la oferta seleccionada
   * @param offerInProcess oferta a validar
   */
  validateOfferInProcess(offerInProcess: any) {
    if (this.sesion.isIdsession()) {
      if (localStorage.getItem('companyId') != null && localStorage.getItem('offerId') != null) {
        if (!offerInProcess.isApplied) {
          // Verificar que ecsInfo esté cargado antes de acceder a sus propiedades
          const hasValidatedPhone = this.sesion.ecsInfo &&
            this.sesion.ecsInfo.params &&
            this.sesion.ecsInfo.params[3] &&
            this.sesion.ecsInfo.params[3].value;

          if (offerInProcess.settings.aws) {
            const isDoctorPeso = CONECTAS_ROUTE_MAP[offerInProcess.company?.id] === 'doctorpeso';
            if (hasValidatedPhone && !isDoctorPeso) {
              this.load.openBcConecta();
            } else {
              this.sesion.confirmTelephoneConecta = true;
              // Llamar a validateSoftFilters en lugar de abrir directamente el modal
              this.offer.offerSelected = offerInProcess;
              this.offer.validateSoftFilters();
            }
          } else {
            this.sesion.confirmTelephoneConecta = false;
            // Llamar a validateSoftFilters para validar antes de abrir el modal
            this.offer.offerSelected = offerInProcess;
            this.offer.validateSoftFilters();
          }
        }
        this.offer.clearOfferlocalStorage();
      }
    }

  }

  /**
   * Funcion para validar que el labelType sea valido y si no lo es retorna una configuracion basica
   * @returns Objeto de configuracion de etiqueta
   */
  getConfigLabel() {
    if (this.offerUnique != undefined) {
      if (this.configLabel[this.offerUnique.labelType] != undefined) {
        return this.configLabel[this.offerUnique.labelType];
      }
    }
    return this.configLabel['0'];
  }

  backOffers(event: MouseEvent) {
    this.dataLayerService.dl_eventoGA4_offer_return(this.offerUnique.card.productName, (event.target as HTMLElement).innerText)
    if (this.cookie == "") {
      this.router.navigate(['/categoria/creditos']);
    } else {
      this.router.navigate(['/ofertas']);
    }
  }
}
